/**
 * Which authentication the app is running (MP-MIG-003).
 *
 * Two modes exist at once during the cutover, exactly as they do on the
 * backend, and for the same reason: the switch has to be reversible without a
 * rebuild of everything.
 *
 * - **legacy** — `simplejwt`. The SPA holds an access and a refresh token in
 *   `localStorage`, sends `Authorization: Bearer`, and refreshes on a 401.
 * - **bff** — the session cookie is the only credential the browser holds. The
 *   tokens live in the Django session and never reach JavaScript
 *   (ADR-0001 §4.1), so there is nothing here to store, refresh or steal.
 *
 * This mirrors `MAMBA_AUTH_CUTOVER` on the backend and **must be flipped at the
 * same time**. With the backend flipped and this not, the SPA keeps sending a
 * bearer token the backend no longer accepts; with this flipped and the backend
 * not, it sends no token to a backend that still requires one. Either way the
 * symptom is the same — every request 401s — which is why they are one
 * decision and the runbook throws them together.
 */
export const MAMBA_AUTH_CUTOVER: boolean =
  (process.env.REACT_APP_MAMBA_AUTH_CUTOVER || '').toLowerCase() === 'true';

/** Where the BFF's sign-in lives. Fixed by the realm's redirect URI, not chosen here. */
export const BFF_LOGIN_PATH = '/auth/login';
export const BFF_LOGOUT_PATH = '/auth/logout';
